import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import AccessoriesOrders from './orders';
import TimeMarked from './timeMarked';
import KanbanLogistics from './kanban';
import AccessoriesInvoicing from './invoicing';

export const accesoriesRoutes = [
  {
    'component': <AccessoriesOrders type='accessories' />,
    'path': paths.AccessoriesOrders,
  },
  {
    'component': <AccessoriesOrders type='pds' />,
    'path': paths.AccessoriesOrdersPDS,
  },
  {'component': <TimeMarked />, 'path': paths.TimeMarked},
  {'component': <KanbanLogistics />, 'path': paths.KanbanLogistics},
  {'component': <AccessoriesInvoicing />, 'path': paths.AccessoriesInvoicing},
];
